export default __webpack_public_path__ + "static/media/Goremonger's Gauntlets.4e3d96d6.jpg";